var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreloaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 66,
    viewBox: "0 0 70 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3139 24.5956L3.51953 36.3639L46.1545 24.4455C54.6921 20.9675 61.1534 18.3711 61.1534 18.369C57.1383 19.0625 41.522 21.957 27.3139 24.5956Z",
    fill: "url(#paint0_linear_1_1162)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79297 49.684C6.79297 49.684 8.12498 55.1072 9.1927 59.4627C9.2025 59.461 9.2125 59.461 9.2223 59.4627C9.63099 60.7958 10.5113 61.9343 11.6985 62.6655C12.8857 63.3967 14.2987 63.6704 15.673 63.4354C15.6878 63.4608 70.0001 50.2485 70.0001 50.2485L67.2177 38.8884L6.79297 49.684Z",
    fill: "url(#paint1_radial_1_1162)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1903 56.7565L43.0127 56.8623L42.5898 65.6726C42.5898 65.6726 67.8812 51.3164 69.8644 50.272C68.4245 50.6229 55.8613 53.6781 43.1903 56.7565Z",
    fill: "url(#paint2_linear_1_1162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51953 36.364L6.3823 48.0307C6.3823 48.0307 65.8957 33.5245 65.9275 33.6534C65.9592 33.7824 62.5446 19.8576 62.5446 19.8576L3.51953 36.364Z",
    fill: "url(#paint3_linear_1_1162)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78809 49.6862L50.4125 41.8887C59.1911 37.2118 65.9167 33.6429 65.9273 33.6619C65.9041 33.5647 36.0987 40.7998 18.6726 45.0369L6.78809 49.6862Z",
    fill: "url(#paint4_linear_1_1162)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.8477 56.8431C56.8021 53.4433 69.9953 50.2401 69.9953 50.2401L67.2171 38.8884L54.2882 41.1972C51.658 47.9122 47.6514 53.3502 42.8477 56.8431Z",
    fill: "#37C4EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.96 36.0129C61.899 34.5858 65.9183 33.6343 65.9247 33.6703C65.9606 33.8119 62.5418 19.8744 62.5418 19.8744L57.5837 21.2593C58.2942 25.3061 58.0214 31.1077 55.96 36.0129Z",
    fill: "#F9C02E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5682 7.84831C58.7521 5.01303 56.3608 3.01924 53.0139 3.83113L41.992 6.5459C42.3592 7.26751 42.6634 8.01947 42.9012 8.79341C43.1045 9.00626 43.2501 9.26753 43.324 9.55244C43.3817 9.78498 43.3929 10.0266 43.3571 10.2635C43.3214 10.5003 43.2393 10.7279 43.1156 10.933C42.9919 11.1382 42.829 11.317 42.6363 11.4592C42.4435 11.6014 42.2246 11.7043 41.992 11.7619C41.7595 11.8195 41.5179 11.8308 41.281 11.795C41.0441 11.7592 40.8166 11.6772 40.6114 11.5535C40.4063 11.4298 40.2275 11.2669 40.0853 11.0741C39.943 10.8813 39.8402 10.6624 39.7826 10.4299C39.6971 10.078 39.7244 9.70817 39.8608 9.37272C39.9581 9.66027 40.0469 9.95204 40.1209 10.2523L42.4783 9.66872C41.5879 6.37042 39.4421 3.55154 36.4999 1.81511C33.5577 0.0786829 30.0528 -0.437395 26.735 0.377282C23.4171 1.19196 20.5499 3.27269 18.7465 6.17436C16.9432 9.07603 16.347 12.5682 17.0855 15.9038L19.0899 15.4112C19.0899 15.4387 19.0899 15.4683 19.1089 15.4957H19.092C19.1735 15.8118 19.1687 16.1439 19.0782 16.4574C18.9876 16.771 18.8146 17.0545 18.5773 17.2784C18.3399 17.5024 18.0468 17.6586 17.7285 17.7307C17.4102 17.8029 17.0784 17.7883 16.7676 17.6886C16.4569 17.5889 16.1786 17.4077 15.9617 17.1638C15.7448 16.92 15.5973 16.6224 15.5345 16.3021C15.4718 15.9819 15.4961 15.6506 15.6049 15.343C15.7137 15.0353 15.903 14.7624 16.1531 14.5528C16.0886 14.0068 16.0554 13.4576 16.0537 12.9078L4.33415 15.7833C4.33415 15.7833 4.33415 15.7833 4.33415 15.796H4.31934C2.87773 16.1506 1.63248 17.056 0.850667 18.318C0.0688533 19.5801 -0.187262 21.0983 0.13725 22.547H0.124565L1.79698 29.3614C1.79698 29.3614 62.1033 18.0794 62.1413 18.2169L59.5936 7.83774L59.5682 7.84831ZM27.3589 2.51814C29.5421 1.98308 31.839 2.15883 33.9154 3.01979C35.9917 3.88075 37.7391 5.38199 38.903 7.30493L19.3415 12.1044C19.4829 9.86104 20.3368 7.72141 21.7789 5.99714C23.221 4.27287 25.1759 3.05403 27.3589 2.51814Z",
    fill: "url(#paint5_radial_1_1162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1162",
    x1: 34.0396,
    y1: 36.3475,
    x2: 30.067,
    y2: 15.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F1634C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E8574E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#D03652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BE1E55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_1162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3989 49.9467) rotate(-13.79) scale(22.3482 22.3482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20C1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CAEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1162",
    x1: 56.6245,
    y1: 59.5782,
    x2: 54.6414,
    y2: 51.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#018EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#018A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#038091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#047280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1162",
    x1: 55.7448,
    y1: 28.8346,
    x2: 11.4641,
    y2: 39.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1162",
    x1: 37.5241,
    y1: 46.935,
    x2: 36.0745,
    y2: 40.3547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFDD0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FDD910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F8CC13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EFB618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E3991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D37328"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_1162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.287 12.8476) rotate(-13.79) scale(23.5343 23.5343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB377D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloaderIcon);
export default __webpack_public_path__ + "static/media/preloader-icon.3feefb873f98d3106f02c9f6e6ae95e8.svg";
export { ForwardRef as ReactComponent };